import { Alert } from "antd";

export const NoneLoginPage = () => (
    <Alert
        message="Authentication Disabled"
        description="Authentication is disabled due to configuration settings. This mode is intended for development purposes only."
        type="info"
        showIcon
        style={{ marginTop: "20px" }}
    />
);
